import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { expand } from '../utils/icons';

const ExpansionWrapper = styled.div`
  border-bottom: 1px solid #000000;

  &:last-child {
    border-bottom: 0;
  }

  ${props =>
    props.alternate &&
    css`
      border: none;
      border-radius: 20px;
      margin-bottom: 1rem;
      background-color: #f5f6f6;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);

      &:first-child {
        margin-top: -1.5rem;
      }
    `};
`;

const ExpansionHeader = styled.a`
  color: #000000;
  font-weight: 600;
  text-transform: uppercase;
  padding: 1rem 3.5rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  cursor: pointer;
  border-radius: 20px;
  text-decoration: none;

  ${props =>
    props.alternate &&
    css`
      font-weight: bold;
      color: #fff;
      background-color: ${props => props.theme.tertiary};
      padding-left: 1.75rem;
      padding-right: 1.75rem;
    `};

  ${props =>
    props.expanded &&
    css`
      border-radius: 20px 20px 0 0;
    `};
`;

const ExpandIcon = styled.span`
  svg {
    transition: transform 0.2s ease-in-out;
    transform: rotate(180deg);

    path {
      fill: ${props => props.theme.tertiary};
    }

    ${props =>
      props.open &&
      css`
        transform: rotate(0deg);
      `};

    ${props =>
      props.alternate &&
      css`
        path {
          fill: #fff;
        }
      `};
  }
`;

const ExpandableItemContent = styled.div`
  padding: 1.75rem;
  border-radius: 0 0 20px 20px;
  color: #161e21;
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.4285714286em;
`;

class ExpandableItem extends Component {
  state = {
    open: this.props.open || false
  };

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { label, children, alternate } = this.props;
    const { open } = this.state;

    return (
      <ExpansionWrapper alternate={alternate}>
        <ExpansionHeader
          href="#"
          onClick={e => {
            e.preventDefault();
            this.toggleOpen();
          }}
          alternate={alternate}
          expanded={open}
        >
          <span>{label}</span>
          <ExpandIcon open={open} alternate={alternate}>
            {expand}
          </ExpandIcon>
        </ExpansionHeader>
        {open && children}
      </ExpansionWrapper>
    );
  }
}

ExpandableItem.defaultProps = {
  alternate: false
};

ExpandableItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  alternate: PropTypes.bool
};

export default ExpandableItem;
export { ExpandableItemContent };



// WEBPACK FOOTER //
// ./src/components/ExpandableItem.js